import React from 'react';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const ForgotYourPasscodePopup = (props) => {
    const { useSmsText, loginWithSmsButton } = usePageMessages();
    return (
        <SimplePopup text={useSmsText} popupRef={props.popupRef} onPopupClose={props.onPopupClose}>
            <PopupButton iconName="arrow-forward" text={loginWithSmsButton} popupRef={props.popupRef} onClick={props.buttonOnClick} />
        </SimplePopup>
    );
};

export default ForgotYourPasscodePopup;
